import React from "react";
import { NavLink } from "react-router-dom";

export default function Settings() {
  return (
    <>
      <div className="container d-flex justify-content-between mt-5">
        <div className="row">
          <div className="col-12">
            <div className="pageTitle">
              <h1>Settings</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-xxl-6 col-xl-6 col-md-6 col-6 mb-3">
            <NavLink to="/settings/email">
              <div className="block">
                <b>Email</b>
              </div>
            </NavLink>
          </div>
          <div className="col-xxl-6 col-xl-6 col-md-6 col-6 mb-3">
            <div className="block">
              <b>Onboarding</b>
            </div>
          </div>
          <div className="col-xxl-6 col-xl-6 col-md-6 col-6 mb-3">
            <NavLink to="/settings/profile">
              <div className="block">
                <b>Profile</b>
              </div>
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
}
